import { render, staticRenderFns } from "./CommodityAllocationListFunc.vue?vue&type=template&id=805d0e72&scoped=true"
import script from "./CommodityAllocationListFunc.vue?vue&type=script&lang=js"
export * from "./CommodityAllocationListFunc.vue?vue&type=script&lang=js"
import style0 from "./CommodityAllocationListFunc.vue?vue&type=style&index=0&id=805d0e72&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "805d0e72",
  null
  
)

export default component.exports